import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store";
import { fetchWrapper } from "../../helpers/fetch-wrapper";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Index = () => {
  const isAuth = useSelector((state) => state.auth.isAuth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoggedOut, setIsLoggedOut] = useState(false);

  useEffect(() => {
    if (isAuth) {
      handleLogout();
    }
  }, [isAuth]);

  useEffect(() => {
    if (isLoggedOut) {
      // console.log("is auth user?", isAuth);
      setTimeout(() => {
        // navigate("/home");
        window.location.href = "/login";
      }, 3200);
    }
  }, [navigate, isLoggedOut]);

  const handleLogout = () => {
    fetchWrapper
      .post(config.apiUrl + "/user/logout")
      .then((response) => {
        setIsLoggedOut(true);
        // console.log(response);

        sessionStorage.clear();
        localStorage.clear();

        toast.success("Déconnexion réussie");

        // dispatch(authActions.logout());
      })
      .catch((e) => {
        console.log("error logout", e);
        sessionStorage.clear();
        localStorage.clear();
        toast.error("Une erreur s'est produite lors de la déconnexion");
        dispatch(authActions.logout());
        setTimeout(() => {
          window.location.href = "/login";
        }, 3200);
      });
  };

  return <></>;
};

export default Index;